import { render, staticRenderFns } from "./PreviewCommissionRule.vue?vue&type=template&id=6fed433a&"
import script from "./PreviewCommissionRule.vue?vue&type=script&lang=ts&"
export * from "./PreviewCommissionRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports